import Services from "../../../services";

class LokasiKerjaApi {
  get() {
    return Services.get("/hrda/lokasi_kerja");
  }

  getPage(page, dataLength, key) {
    return Services.get(`/hrda/lokasi_kerja/page/?per_page=${dataLength}&page=${page}&q=${key}`);
  }

  getDropdown() {
    return Services.get("/hrda/lokasi_kerja/dropdown");
  }

  search(key) {
    return Services.get("/hrda/lokasi_kerja/page/?per_page=10&page=1&q=" + key);
  }

  show(value) {
    return Services.put("/hrda/lokasi_kerja/show", value);
  }

  hide(value) {
    return Services.put("/hrda/lokasi_kerja/hide", value);
  }

  create(value) {
    return Services.post("/hrda/lokasi_kerja", value);
  }

  update(value) {
    return Services.put("/hrda/lokasi_kerja", value);
  }

  delete(value) {
    return Services.post("/hrda/lokasi_kerja/delete", value);
  }
}

export default new LokasiKerjaApi();
